import React from 'react';
import AnimatedHeight from '../../shared/animated_height';
import RequirementItem from './requirement_item';
import { useContainerStyle } from './use_styles';
import { RequirementsPropTypes } from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Requirements = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    error,
    hideRequirements,
    isCompact,
    requirements = undefined,
    requirementsErrorTitle
  } = _ref;
  var styles = useContainerStyle({
    isCompact
  });
  var hasContent = !hideRequirements || error && hideRequirements;
  return ___EmotionJSX("div", {
    css: hasContent && styles.container,
    ref: ref
  }, error && hideRequirements && ___EmotionJSX(RequirementItem, {
    label: requirementsErrorTitle,
    status: "error"
  }), ___EmotionJSX(AnimatedHeight, {
    in: !hideRequirements
  }, !hideRequirements && requirements.map(item => ___EmotionJSX("div", {
    key: "itemContainer-".concat(item.id)
  }, ___EmotionJSX(RequirementItem, {
    label: item.label,
    status: item.status
  }), item.requirements && Array.isArray(item.requirements) && ___EmotionJSX("div", {
    css: styles.subContainer
  }, item.requirements.map(subItem => ___EmotionJSX(RequirementItem, {
    key: "subItemsContainer-".concat(subItem.id),
    label: subItem.label,
    status: subItem.status
  })))))));
});
Requirements.propTypes = RequirementsPropTypes;
Requirements.displayName = 'PasswordRequirements';
export default Requirements;